import { HEADER_TOGGLE } from "@common/constants/action-types";
export var toggleHeader = function(isHidden) {
    return function(dispatch) {
        dispatch({
            type: HEADER_TOGGLE,
            payload: isHidden
        });
    };
};
